import { getLatestCompletedQuarterRange } from '@koda/koda-utils/date';
import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, BusinessInformation } from './types/businessInformation';
import { CinemaPayload } from './types/payloads';

export const CINEMA_CONTENT_PATH = 'licenses.steps.businessInformation.forms.cinema';

export const cinemaSchema = BasicBusinessInformationSchema.extend({
  revenue: z
    .number({ required_error: `${CINEMA_CONTENT_PATH}.revenue.validation.required` })
    .min(1, { message: `${CINEMA_CONTENT_PATH}.revenue.validation.required` }),
});

export type CinemaForm = z.infer<typeof cinemaSchema>;

export const createCinemaDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.Cinema,
});

export const toPayloadCinema = (form: CinemaForm, wareNumber: number): CinemaPayload => {
  const { start } = getLatestCompletedQuarterRange();
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs(start).format('YYYY-MM-DD'),
    quantity: form.revenue ? form.revenue : 0,
  };
};
